import { Box, Skeleton, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import { IMilkingProcessStats } from 'models/MilkingProcess'
import { useMemo } from 'react'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
type ShiftIndicatorsCardProps = {
	stats: IMilkingProcessStats
	isLoading: boolean
}

export const ShiftIndicatorsCard = (props: ShiftIndicatorsCardProps) => {
	const sumDeviation = useMemo(() => {
		const am = props?.stats?.am ?? 0
		const pm = props?.stats?.pm ?? 0
		const night = props?.stats?.night ?? 0

		return am + pm + night
	}, [props?.stats?.am, props?.stats?.night, props?.stats?.pm])

	const hasData = useMemo(() => {
		return [props?.stats?.am, props?.stats?.pm, props?.stats?.night].some(
			v => v !== null && v !== undefined,
		)
	}, [props?.stats?.am, props?.stats?.night, props?.stats?.pm])

	return (
		<CardStandart sx={{ p: '24px', height: '100%' }}>
			<Stack
				direction={'column'}
				justifyContent={'space-between'}
				sx={{ height: '100%' }}
			>
				<Stack direction='column' gap='8px'>
					{props.isLoading ? (
						<>
							<Skeleton width='30%' height={20} />
							<Skeleton width='60%' height={20} />
						</>
					) : hasData ? (
						<>
							<TypographyPrimary16Bold sx={{ color: COLORS.error }}>
								{sumDeviation}
							</TypographyPrimary16Bold>
							<TypographyPrimary>Отклонений в рутине доения</TypographyPrimary>
						</>
					) : (
						<>
							<TypographySecondary>Нет данных</TypographySecondary>
							<TypographyPrimary>Отклонений в рутине доения</TypographyPrimary>
						</>
					)}
				</Stack>

				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			</Stack>
		</CardStandart>
	)
}
